export default {
	noDataText: "Sin datos disponibles",
	loading: "Cargando...",
};
